<template>
	<div class="rp-conv-rating-component">
		<div class="rating">
			<!--Title before submit-->
			<label class="rp-rate-title" v-if="!alreadySubmitted">
				{{ $t('rating.askedHeader')}}
			</label>
			<!--Title After submit-->
			<label class="rp-rate-title" v-if="alreadySubmitted">
				{{ $t('rating.successHeader')}}
				<img
				:title="selectedEmoji.name"
				:alt="selectedEmoji.name"
				class="selected-emoji-img"
				:class="'rating-'+selectedEmoji.id"
				:src="emojiBaseURL+selectedEmoji.imgUrl"
				/>
				<br/>
				<div class="rp-thanks-message">{{ $t('rating.thanksMessage')}}</div>
			</label>
			<!-- Display Emoji selector before submit --->
			<div class="input" v-if="!alreadySubmitted">
				<br />
				<!---Emoji Selector--->
				<div class="emoji-selector">
					<span v-for="emoji in emojies" :key="emoji.id">
						<input
						type="radio"
						name="emojiIndex"
						:id="'rating'+emoji.name"
						:value="emoji.id"
						required="required"
						v-model="getValue"
						/>
						<label :for="'rating'+emoji.name">
						<img
							:title="emoji.name"
							:alt="emoji.name"
							class="emoji-img"
							:class="'rating-'+emoji.id"
							:src="emojiBaseURL+emoji.imgUrl"
						/>
						</label>
					</span>
				</div>
				<div 
					v-if="getValue>0"
				><br />
					<!--- Input text area--->
					<el-input
						type="textarea"
						:maxlength="200"
						rows="4"
						:autosize="{ minRows: 4, maxRows: 8 }"
						show-word-limit
						v-model="feedback.vModelValue"
						:disabled="loading"
						@keyup.enter.native.exact="handleFeedbackSubmit"
						:placeholder="$t('rating.placeholderForRatingFeedback')"
					/>
					<!--- Submit Button--->
					<el-button
						@click="handleFeedbackSubmit"
						type="primary"
						:loading="loading"
						class="rp-feedback-submit"
					>
						<PaperPlane />
					</el-button>
				</div>
			</div>
    </div>
		<div class="rating-value"  v-if="alreadySubmitted">
        <div class="rp-feedback-value">{{ feedback.value }}</div>
    </div>
	</div>
</template>
<script>
import {emojiBaseURL, emojies} from '../../constants'
import PaperPlane from '@/components/Images/PaperPlane'
export default {
	components: {
		PaperPlane
	},
	data() {
		return {
			emojiBaseURL,
			emojies,
			loading: false,
		}
	},
	props: {
		value: {
			type: String,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		feedback: {
			type: Object,
			default: '',
		}
	},
	computed: {
		getValue: {
			get() {
				return parseInt(this.value);
			},
			set(val) {
				if(val>=1) {
					this.$emit('ratingUpdated', val)	
				}
			}
		},
		alreadySubmitted() {
			return !!this.feedback.value;
		},
		isItDisabled() {
			return this.disabled || this.getValue>=1 ? 'disabled' : '';
		},
		// loading() {
		// 	this.feedback.isLoading;
		// },
		selectedEmoji() {
      return this.emojies.find(emoji => emoji.id === this.getValue) || this.emojies[0];
    }
	},
	methods: {
		handleFeedbackSubmit() {
			const { feedback } = this;
			if(feedback.vModelValue) {
				this.$set(feedback, "isLoading", true)
				this.loading = true;
				this.$emit('feedbackUpdated', { type: 'form', data: { property: feedback } });
			}
		},
	}
}
</script>
<style lang="scss" >
.rp-conv-rating-component {
	display: inline-block;
	background: white;
	border: 1px solid $greyColor;
	border-top: 2px solid $color;
	border-radius: 5px;
	box-shadow: 1px 3px 8px rgba(0, 0, 0, 0.1);
	.rating {
		padding: 1.5rem;
		text-align: center;
		textarea {
			font-family: $font;
		}
	}
	.rating-value {
		border-top: 1px solid #d4dadf;
		.rp-feedback-value {
			padding: 1.5rem;
			font-size: 14px;
			color: #8f919d;
			text-align: center;
		}
	}
    .disabled {
      pointer-events: none;
    }
    .rp-rate-title {
      font-size: 14px;
      font-weight: 400;
      .selected-emoji-img {
        height: 25px;
        width: 25px;
        vertical-align: middle;
      }
    }
    .rp-feedback-submit {
      margin-top: 30px;
      background: rgb(0, 78, 150);
	  border-color: #004e96 !important;
	  &:hover {
		border-color: #004e96 !important;
		i {
			color: #004e96;
	  	}
	  }
		svg {
			fill: #fff;
		}
		&:hover{
			svg {
				fill: #004e96;
			}
		}
	  
    }
	.rp-thanks-message {
		font-size: 14px;
		color: #8f919d;
		text-align: center;
	}
    .emoji-selector {
      .emoji-img {
        margin-left: 15px;
        height: 32px;
        width: 32px;
        transition: all 100ms ease-in;
        filter: grayscale(1) opacity(0.3);
        cursor: pointer;
      }
      .emoji-img.rating-1 {
        margin-left: unset;
      }
      input[type="radio"]:checked + label .emoji-img,
      input[type="radio"]:hover + label .emoji-img {
        transform: scale(1.35);
        filter: none;
      }
      input[type="radio"] {
        margin: 0;
        padding: 0;
        position: absolute;
        visibility: hidden;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
      }
    }
}
</style>